import ModelStatus from './ModelStatus.js';
import Emitter from '../core/Emitter.js';
import Utility from '../core/Utility.js';

var id = 0;

class Model extends Emitter {
	constructor(datasource, query, datasourceChangeHandler, isStream) {
		super();
		this.isStream = isStream;
		this.client = new Araqne.QueryService(window.currentSession);
		this.datasource = datasource;
		if(!!datasource){
 			this.datasource = datasource;
 			$(this.datasource).on('filter', Utility.throttle(this.handleFilterChanged.bind(this), 1000, this));
 		}
		this.query = query || '';
		this.status = ModelStatus.Initial;
		this.queryAfter = '';
		//this.prependParams = {};
		this.objectId = '<#Model:' + (id++) + '>';
		this.toString = function() {
			return this.objectId;
		};
		this.setString = '';

		this.FILTER_MACRO_REGEX = /(\s)*\$filter\$(\s)*/gi;
		this.DRILLDOWN_MACRO_REGEX = /(\s)*\$drilldown\$(\s)*/gi;

		this.FILTER_MACRO_WITH_PIPE_REGEX = /(\|)*(\s)*\$filter\$(\s)*/gi;
		this.DRILLDOWN_MACRO_WITH_PIPE_REGEX = /(\|)*(\s)*\$drilldown\$(\s)*/gi;

		this.datasourceChangeHandler = datasourceChangeHandler;

		// $(this.datasource).on('filter', Utility.throttle(this.handleFilterChanged.bind(this), 1000, this));

	}

	escapeSpecialCh(string){
		var escaped = string.replace(/\"/gi,"\\\"");
		return `"${escaped}"`;
	}

	buildSetString(key, value, valType){
		var escaped = '';
		if(!value){
			return escaped;
		}
		if(!!valType && valType === 'date'){
			escaped = value;
		} else if(Array.isArray(value)){
			if(value.length > 1){
				var tmpArr = [];
				value.forEach( (v) => {
					var tmp = this.escapeSpecialCh(v);
					tmpArr.push(tmp);
				});
				escaped = `array(${tmpArr.join(',')})`;
				return `set ${key}=${escaped}`;
			} else {
				escaped = this.escapeSpecialCh(value[0]);
			}
		} else {
			escaped = this.escapeSpecialCh(value);
		}
		return `set ${key}=${escaped}`;
	}

	setPrependParams(params) {
		
		if(params.length === 0){
			this.setString = '';
			return;
		}
		var arr = [];

		params.forEach( (param)=> {
			var prependParams = param.detail; // key, value map of set string, can be array
			var valType = param.valType;
			
			for(var key in prependParams) {
				// arr.push(`set ${key}="${this.prependParams[key]}"`);
				arr.push(this.buildSetString(key, prependParams[key] , valType));
			}
		});

		if(arr.length > 0) {
			this.setString = `${arr.join('|')} | `;
		}
	}

	// setAfterQuery(query) {
	// 	this.queryAfter = query;
	// 	this.restart();
	// 	//this._removeQuery(this._runQuery.bind(this));
	// }

	setAfterQueryString(query){
		this.queryAfter = query;
	}

	// clearAfterQuery() {
	// 	this.queryAfter = '';
	// 	this.restart();
	// 	//this._removeQuery(this._runQuery.bind(this));
	// }

	clearAfterQueryString() {
		this.queryAfter = '';
	}

	update(datasource, query) {
		if(!!this.datasource){
			$(this.datasource).off('filter');
		}
		this.datasource = datasource;
		this.query = query || '';
		if(!!this.datasource){
 			$(this.datasource).on('filter', Utility.throttle(this.handleFilterChanged.bind(this), 1000, this));
 		}
	}

	request() { // only for original widget.
		if(this.status !== ModelStatus.Initial) {
			this._removeQuery(this._runQuery.bind(this));
		}
		else {
			this._runQuery();
		}
	}

	stopRequest(callback) {
		if(!!callback){
			this._removeQuery(callback);
		} else {
			this._removeQuery(() => {});
		}
	}

	getResult(offset, limit, isFiltered) {
		this.client.getResult(this.queryId, offset, limit, true)
		.onSuccess(resp => {
			this.status = ModelStatus.Completed;
			var e = new Event('rows');
			e.detail = resp;
			if (Array.isArray(e.detail.result))
				e.detail.result.isFiltered = isFiltered;
			this.dispatchEvent(e);

			this.stopRequest();
			//this._removeQuery(() => {});
		})
	}

	_removeQuery(callback) {
		if(!this.queryId){
			// issue2651, change model status as Initial if there is no query id and run callback
			this.status = ModelStatus.Initial;
			if(callback) {
				callback();
			}
			return;
		}
		this.status = ModelStatus.PendingRemoving;
		this.client.removeQuery(this.queryId)
		.onSuccess(() => {
			// if(this.stauts === ModelStatus.PendingRemoving){
			// 	this.queryId = undefined;
			// 	this.status = ModelStatus.Initial;
			// }
			callback();
			// this.status = ModelStatus.Initial;
		})
		.onFailure((m, raw) => {
			console.warn('removeQuery failure', m,raw);
			// if(this.stauts === ModelStatus.PendingRemoving){
			// 	this.queryId = undefined;
			// 	this.status = ModelStatus.Initial;
			// }
			callback();
			// this.status = ModelStatus.Initial;
		});
	}

	/*
		routine:
		1. 사용자가 그리드 위젯에서 필터 설정
		2. GridService.js: this.scope.applyFilter() 에서 필터를 토대로 생성된 쿼리와
			after라는 프로퍼티가 true로 설정되어서 발생
		3. Widget.jsx: addDrilldownEvent() 의 `$(this.rendered).off('filter').on('filter')`에서
			filter 이벤트 받은 뒤 model.setAfterQuery() 실행함
		4. model.js: setAfterQuery()에서 _runQuery() 실행
		5. model.js _runQuery() 에서 $filter$ 매크로가 사용되었으면, 해당 부분 치환되서 쿼리 실행 됨
	 */

	buildQueryString(hasMacro = false) {
		var queryString = '';

		if(!this.datasource) {
			var instantQuery = this.query || '';	// instant 쿼리

			queryString = `${this.setString} ${instantQuery}`;
		}else {
			var datasourceQuery = hasMacro ? this.datasource.getQuery() : this.datasource.getQueryWithFilters();	// 데이터 소스 쿼리
			var	customQuery = !!this.query ? `| ${ this.query.replace(/^\s*\|/, '') }` : ''; // 사용자 정의 쿼리

			queryString = `${this.setString} ${datasourceQuery} ${customQuery}`;
		}

		return queryString;
	}

	hasMacro(queryString) {
		if(!queryString){
			return false;
		}

 		const MACRO_REGEX = /(\s)*\$(filter|drilldown)\$(\s)*/gi;
 		return queryString.match(MACRO_REGEX);
 	}

	replaceQueryMacro(queryString, filterQueryString, regex, regexWithPipe){
		let convertedFilterQueryString = !!filterQueryString ? ` ${filterQueryString}` : null;
		if(convertedFilterQueryString === null){
			queryString = queryString.replace(regexWithPipe, '');
		} else {
			queryString = queryString.replace(regex, convertedFilterQueryString);
		}
		return queryString;
	}

	/*
		1. queryString에 매크로가 있는지 없는지 검사
			1. $filter$ - this.queryAfter
			2. $drilldown$ - this.datasource.getFilters()
	*/

	_runQuery(streamingTrap) {
		let queryString = '';
		let isFiltered = (this.queryAfter != "" || (!!this.datasource && !!this.datasource.getFilters() && this.datasource.getFilters().length > 0));

		// $filter$ 혹은 $drilldown$이 있는지 검사
		if(this.hasMacro( !!this.datasource ? this.datasource.getQuery() : '' ) || this.hasMacro(this.query) ) {
			queryString = this.buildQueryString(true);
			let gridFilterQuery = null; 
			if(!!this.queryAfter){
				gridFilterQuery = this.queryAfter;
			}
			let drilldownQuery = null;
			if(!!this.datasource){
				drilldownQuery = this.datasource.getFilters();
			}

			queryString = queryString.replace(/\n/gi, ' '); // remove newline
			if(queryString.match(this.FILTER_MACRO_REGEX)) {
				queryString = this.replaceQueryMacro(queryString, gridFilterQuery, this.FILTER_MACRO_REGEX, this.FILTER_MACRO_WITH_PIPE_REGEX);
			}

			if(queryString.match(this.DRILLDOWN_MACRO_REGEX)) {
				if(drilldownQuery) {
					drilldownQuery = drilldownQuery.join(' | ');
				}
				queryString = this.replaceQueryMacro(queryString, drilldownQuery, this.DRILLDOWN_MACRO_REGEX, this.DRILLDOWN_MACRO_WITH_PIPE_REGEX);
			}
		} else {
			queryString = this.buildQueryString(false);
			let filterQuery = !!this.queryAfter ? `| ${this.queryAfter}` : '';
			queryString = `${queryString} ${filterQuery}`;
		}

		if(this.status !== ModelStatus.PendingRemoving) {
			// console.log('----------', this.status, this.queryId, this.toString());
			// console.trace();
			if(this.status !== ModelStatus.Initial) {
				return;
			}
		}

		this.status = ModelStatus.PendingCreating;

		//console.log('------queryString', queryString);
		this.dispatchEvent(new Event('started'));
		// console.log(queryString)
		this.client.createQuery(queryString, query => {
			this.status = ModelStatus.Pending;
			this.queryId = query.id;

			query
			.onTail((resp) => {
				var e = new Event('eof');
				e.isFiltered = isFiltered;
				e.resp = resp;
				this.status = ModelStatus.PendingFetching;
				this.dispatchEvent(e);

			})
			.onError(resp => {
				var e = new Event('failed');
				e.detail = resp.error_detail;
				this.dispatchEvent(e);
			})
			if(!!this.isStream){
				query.onRows((resp)=>{
					var e = new Event('rows');
					e.resp = angular.copy(resp);
					this.dispatchEvent(e);
					if(!!streamingTrap){
						streamingTrap();//Trap이 일어났을때 실행할 callback 보통 아무동작도 하지 않는다.
					}
				});

				query.startStreamQuery();
			} else {
				query.start();
			}
		}, (resp) => {
			var e = new Event('failed');
			e.detail = resp.errorMessage || resp.errorCode;
			this.dispatchEvent(e);
		});
	}

	removeDatasourceEvent(){
		this.datasourceChangeHandler = null;
	}

	setDatasourceEvent(handler){
		this.datasourceChangeHandler = handler;	
	}

	handleFilterChanged(event) {
		if(!this.datasourceChangeHandler){
			return;
		}
		
		this.datasourceChangeHandler(event);
	}
}

export default Model;
if(typeof WebConsole === 'undefined') {
	window.WebConsole = {};
}
if(typeof window.WebConsole.Services === 'undefined') {
	WebConsole.Services = {};
}
WebConsole.Services.Model = Model;


// WEBPACK FOOTER //
// ./resources/WEB-INF/src/data/Model.js